import { render, staticRenderFns } from "./LessonItem.vue?vue&type=template&id=5112d8f6&scoped=true"
import script from "./LessonItem.vue?vue&type=script&lang=js"
export * from "./LessonItem.vue?vue&type=script&lang=js"
import style0 from "./LessonItem.vue?vue&type=style&index=0&id=5112d8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5112d8f6",
  null
  
)

export default component.exports